import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { InputDatePicker } from "@/components/elements/InputDatePicker";
import { Select } from "@/components/elements/Select";
import { Grid, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { LearnerFormTitle } from "@/features/learner/components/learner-form/LearnerFormTitle";
import { useEnum } from "@/api/services/global/enum";
import { TOption } from "@/types/common";
import { useParams } from "react-router-dom";
import { text } from "@/theme/colors";

type TLearnerExamInfoProps = {
  isLoadingIndustryList: boolean;
  industryOptions: TOption[];
}

export const LearnerExamInfoForm: FC<TLearnerExamInfoProps> = ({ isLoadingIndustryList, industryOptions }) => {
  const { control } = useFormContext<TLearnerForm>();
  const { learnerId } = useParams();
  const { data: japaneseLevelTypeOptions } = useEnum("EJapaneseLevelType");

  return (
    <InnerBox title={<LearnerFormTitle text="分野・日本語能力・試験記録" />} showDivider={false}>
      <Typography component="p" variant="body14" color={text.secondary} mb={2}>受験分野は後から変更できません。別分野の計画を立てる場合は、アーカイブしてから外国人を再作成してください。</Typography>
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="industryId">
            <Select loading={isLoadingIndustryList} options={industryOptions} readonly={!!learnerId} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="japaneseLanguageLevel">
            <Select placeholder="選択してください" options={japaneseLevelTypeOptions} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="lastExamDate">
            <InputDatePicker placeholder="2022/01/01" />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="lastExamScore">
            <Input />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
